import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, Button } from '@mui/material';

const LogoutPopup = ({ onLogout, onDismiss }) => {
  return (
    <Dialog open onClose={onDismiss}>
      <DialogContent>
        <DialogContentText>
          You have been inactive for a while. Do you want to stay logged in?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onDismiss} color="primary">
          Stay Logged In
        </Button>
        <Button onClick={onLogout} color="secondary">
          Log Out
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LogoutPopup;
